const optionsReducer = (state = [], action) => {
    switch (action.type) {
        case "setOptions":
            return action.payload;
        default:
            return state;
    }
};

export default optionsReducer;
